/**
 * Returns the given URL string with any route prefix applied.
 *
 * @param {string}   url - Bare URL string path.
 *
 * @returns {string} URL with added route prefix.
 */
function getRoutePrefix(url)
{
   return globalThis.foundry.utils.getRoute(url);
}

export { getRoutePrefix };
//# sourceMappingURL=index.js.map
